export interface SeoProps {
	title: string
	description?: string
	canonical?: string
	keywords?: string[]
	robots?: string
	openGraph?: {
		title?: string
		description?: string
		image?: string
		type?: string
		url?: string
		siteName?: string
	}
	twitter?: {
		title?: string
		description?: string
		image?: string
		site?: string
		creator?: string
		card?: 'summary_large_image' | 'summary'
	}
	structuredData?: Array<object | string>
	extraMeta?: Array<{ name?: string; property?: string; content: string }>
}

export function Seo({
	title,
	description,
	canonical,
	keywords,
	robots,
	openGraph,
	twitter,
	structuredData = [],
	extraMeta = [],
}: SeoProps) {
	return (
		<>
			<title>{title}</title>
			{description ? <meta name="description" content={description} /> : null}
			{canonical ? <link rel="canonical" href={canonical} /> : null}
			{keywords?.length ? (
				<meta name="keywords" content={keywords.join(', ')} />
			) : null}
			{robots ? <meta name="robots" content={robots} /> : null}

			{/* Open Graph */}
			{openGraph?.title ? (
				<meta property="og:title" content={openGraph.title} />
			) : null}
			{openGraph?.description ? (
				<meta property="og:description" content={openGraph.description} />
			) : null}
			{openGraph?.image ? (
				<meta property="og:image" content={openGraph.image} />
			) : null}
			{openGraph?.type ? (
				<meta property="og:type" content={openGraph.type} />
			) : null}
			{openGraph?.url ? (
				<meta property="og:url" content={openGraph.url} />
			) : null}
			{openGraph?.siteName ? (
				<meta property="og:site_name" content={openGraph.siteName} />
			) : null}

			{/* Twitter */}
			{twitter?.card ? (
				<meta name="twitter:card" content={twitter.card} />
			) : null}
			{twitter?.title ? (
				<meta name="twitter:title" content={twitter.title} />
			) : null}
			{twitter?.description ? (
				<meta name="twitter:description" content={twitter.description} />
			) : null}
			{twitter?.image ? (
				<meta name="twitter:image" content={twitter.image} />
			) : null}
			{twitter?.site ? (
				<meta name="twitter:site" content={twitter.site} />
			) : null}
			{twitter?.creator ? (
				<meta name="twitter:creator" content={twitter.creator} />
			) : null}

			{/* Extra meta tags */}
			{extraMeta.map((m, i) =>
				m.name ? (
					<meta key={`n:${m.name}:${i}`} name={m.name} content={m.content} />
				) : (
					<meta
						key={`p:${m.property}:${i}`}
						property={m.property!}
						content={m.content}
					/>
				),
			)}

			{/* JSON-LD structured data */}
			{structuredData.map((sd, i) => (
				<script
					key={i}
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: typeof sd === 'string' ? sd : JSON.stringify(sd),
					}}
				/>
			))}
		</>
	)
}
